(() => {
  const TRACK_SELECTOR = "[data-nappi-reco-track]";
  const PREV_SELECTOR = "[data-nappi-reco-prev]";
  const NEXT_SELECTOR = "[data-nappi-reco-next]";
  function cardStep(track) {
    const card = track.querySelector(".nappi-reco__card");
    if (!card) return track.clientWidth * 0.8;
    const style = window.getComputedStyle(track);
    const gap = parseFloat(style.columnGap || style.gap || "0") || 0;
    return card.getBoundingClientRect().width + gap;
  }
  function updateArrows(track) {
    const wrap = track.closest(".nappi-reco");
    if (!wrap) return;
    const prev = wrap.querySelector(PREV_SELECTOR);
    const next = wrap.querySelector(NEXT_SELECTOR);
    const maxScroll = track.scrollWidth - track.clientWidth - 1;
    if (prev instanceof HTMLButtonElement) prev.disabled = track.scrollLeft <= 0;
    if (next instanceof HTMLButtonElement) next.disabled = maxScroll <= 0 || track.scrollLeft >= maxScroll;
  }
  function refreshAllArrows() {
    document.querySelectorAll(TRACK_SELECTOR).forEach((track) => {
      if (track instanceof HTMLElement) updateArrows(track);
    });
  }
  document.addEventListener("click", (event) => {
    const target = (
      /** @type {HTMLElement} */
      event.target
    );
    const prevButton = target.closest(PREV_SELECTOR);
    const nextButton = target.closest(NEXT_SELECTOR);
    const button = prevButton || nextButton;
    if (!button) return;
    const wrap = button.closest(".nappi-reco");
    const track = wrap?.querySelector(TRACK_SELECTOR);
    if (!(track instanceof HTMLElement)) return;
    track.scrollBy({ left: cardStep(track) * (prevButton ? -1 : 1), behavior: "smooth" });
  });
  document.addEventListener(
    "scroll",
    (event) => {
      const target = (
        /** @type {Node} */
        event.target
      );
      if (target instanceof HTMLElement && target.matches(TRACK_SELECTOR)) {
        updateArrows(target);
      }
    },
    { capture: true, passive: true }
  );
  window.addEventListener("resize", refreshAllArrows);
  const observeRoot = document.getElementById("cart-drawer") || document.body;
  new MutationObserver(refreshAllArrows).observe(observeRoot, { childList: true, subtree: true });
  refreshAllArrows();
})();
(() => {
  const IGNORE = '#cart-drawer, cart-icon, .action__cart, [data-nappi-add], product-form-component, add-to-cart-component, [on\\:click*="cart-drawer"], [data-sticky-add], nappi-sticky-buy, nappi-upsell';
  let openedAt = 0;
  document.addEventListener("theme-drawer:open", (event) => {
    if (event.target instanceof Element && event.target.id === "cart-drawer") openedAt = Date.now();
  });
  document.addEventListener("click", (event) => {
    const drawer = document.getElementById("cart-drawer");
    if (!drawer || typeof drawer.close !== "function") return;
    const dialog = drawer.querySelector("dialog");
    if (!dialog || !dialog.open) return;
    if (Date.now() - openedAt < 400) return;
    const target = event.target;
    if (!(target instanceof Element) || target === document.documentElement) return;
    const path = event.composedPath();
    if (path.some((node) => node instanceof Element && node.matches(IGNORE))) return;
    if (!target.isConnected) return;
    drawer.close();
  });
})();
window.addEventListener("pageshow", async (event) => {
  if (!event.persisted) return;
  try {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" }, cache: "no-store" });
    if (!res.ok) return;
    const cart = await res.json();
    const bubble = document.querySelector(".cart-bubble__text-count");
    const shownCount = !bubble || bubble.classList.contains("hidden") ? 0 : Number(bubble.textContent.trim()) || 0;
    const shownTotal = (document.getElementById("nappi-free-shipping-bar") ?? document.getElementById("nappi-ship-banner"))?.dataset.totalCents ?? "0";
    const drawer = document.getElementById("cart-drawer");
    const shownKeys = drawer ? [...drawer.querySelectorAll("tr[data-key]")].map((row) => row.dataset.key).sort().join() : null;
    const cartKeys = cart.items.map((item) => item.key).sort().join();
    const stale = cart.item_count !== shownCount || drawer && String(cart.total_price) !== shownTotal || shownKeys !== null && shownKeys !== cartKeys;
    if (stale) window.location.reload();
  } catch (e) {
  }
});
(() => {
  const sync = () => {
    const bubble = document.querySelector(".cart-bubble__text-count");
    const n = !bubble || bubble.classList.contains("hidden") ? 0 : Number(bubble.textContent.trim()) || 0;
    document.querySelectorAll("[data-nappi-cart-count]").forEach((el) => {
      const template = n === 1 ? el.dataset.one : el.dataset.other;
      if (!template) return;
      const text = template.split("[n]").join(String(n));
      if (el.textContent !== text) el.textContent = text;
      el.hidden = n === 0;
    });
  };
  const watch = () => {
    const bubble = document.querySelector(".cart-bubble__text-count");
    if (!bubble) return;
    new MutationObserver(sync).observe(bubble, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ["class"] });
  };
  document.addEventListener("theme-drawer:open", sync);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch);
  else watch();
})();
